import React, { useMemo, useState, useEffect, useCallback } from "react";
import { Grid, TextareaAutosize } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

import TopSection from "../../LT/TopSection";
import DataDetails from "./DataDetails";
import ButtonComponent from "../../../components/common/button/Button";
import Modal from "../../../components/common/modal/Modal";
import Cards from "../../../components/common/card/Card";
import { fetchData } from "../../../redux/actions/PriceMemo";
import { moveToDataError } from "../../../redux/actions/MoveToDataErrors";
import { moveToContract } from "../../../redux/actions/MoveToContract";
import { Loader } from '../../../components/common/Loader';
import { getAllSourcePriceMemoData } from "../../../redux/actions/GetAllSourcePriceMemo";
import { getAllSourcePricMemo } from "../../../common/endpoints";
import { TabModal } from "./TabModal";
import { editSisPriceMemoApi } from "../../../redux/actions/EditSisPriceMemo";
import { setSelectedItem } from "../../../redux/actions/SupportTicket/selectionSlice";

const ModalFooter = (props) => {
  return (
    <div className="footer-btn-wrapper">
      <ButtonComponent
        maxWidth="170px"
        label="No"
        bgColor="white"
        color="black"
        onClick={props.onClosePopup}
      />
      <ButtonComponent
        maxWidth="170px"
        label="Yes"
        bgColor="black"
        color="white"
        onClick={props.onSubmit}
        disabled={!props?.errorComment}
      />
    </div>
  );
};

const PriceMemoMaintenance = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [btnDisabled, setIsBtnDisabled] = useState(true);
  const [open, setOpen] = useState(false);
  const [rowsData, setRowsData] = useState([]);
  const [seqId, setSeqId] = useState();
  const [errorComment, setErrorComment] = useState("");
  const [pageSize, setPageSize] = useState(3500);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalPageItems, setTotalPageItems] = useState(0);
  const [totalItemCurrentPage, setTotalItemCurrentPage] = useState(0);
  const [pmSourceData, setPmSourceData] = useState([]);
  const [openSourceModal, setOpenSourceModal] = useState(false);
  const [modalPageSize, setModalPageSize] = useState(30000);
  const [modalCurrentPage, setModalCurrentPage] = useState(1);
  const [modalTotalPages, setModalTotalPages] = useState(0);
  const [modalTotalPageItems, setModalTotalPageItems] = useState(0);
  const [modalTotalItemCurrentPage, setModalTotalItemCurrentPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [otherBtnDisabled, setOtherBtnDisabled] = useState(true);
  const [saveBtnDisabled, setSaveBtnDisabled] = useState(true);
  const piceMemoDataList = useSelector((state) => state?.piceMemoData);

  const procurementDivisionType = useSelector(
    (state) => state?.userCardType?.procurementDivisionType
  );
  const userEmail = localStorage.getItem("data");
  const userName = localStorage.getItem("userName");
  const plantId = localStorage.getItem("selectedCDPlantCode");

  const handleClose = () => {
    setOpen(false);
  };

  const cleanUsername = (name) => {
    return name.replace(/\s*\[C\]/, ""); // Removes "[C]" with optional leading space
  };

  const handleCellValueChange = async (params) => {
    if (rowsData.some(row => row.runOutputSeqId === params.data.runOutputSeqId)) {
      const updatedSelectedRows = rowsData.map(row =>
        row.runOutputSeqId === params.data.runOutputSeqId ? params.data : row
      );
      setRowsData(updatedSelectedRows);
    }
  };

  useEffect(() => {
    const mandatoryFields = ["sapMaterialNumber", "sapPlantId", "sapSupplierId"];
    const areMandatoryFieldsFilled = rowsData.every((row) =>
      mandatoryFields.every(
        (field) =>
          row[field] &&
          row[field].trim() !== "" &&
          row[field] !== "-"
      )
    );
    setIsBtnDisabled(!(rowsData.length > 0 && areMandatoryFieldsFilled));
  }, [rowsData]);

  const handleSaveSisMaterialId = async () => {
    try {
      const saveSisMaterialIds = await dispatch(
        editSisPriceMemoApi({
          params:{
            userId: userEmail,
            userName: cleanUsername(userName),
            plantId: plantId,
          },
          data: rowsData
        })
      );
      if (saveSisMaterialIds?.payload?.Status === "200") {
        toast.success(saveSisMaterialIds?.payload?.responseMessage, {
          autoClose: 2000,
        });
        dispatch(
          fetchData({
            dynamicEndpoint: `api/cd/pricememo/${procurementDivisionType}`,
            params: {
              page: currentPage,
              size: pageSize,
              plantId: localStorage.getItem("selectedCDPlantCode")
            }
          })
        );
        setOpen(false);
        setIsBtnDisabled(true);
        setSaveBtnDisabled(true)
      } else if (saveSisMaterialIds?.payload?.Status === '206') {
        toast.warn(saveSisMaterialIds?.payload?.responseMessage, {
          autoClose: 3000,
        });
        dispatch(
          fetchData({
            dynamicEndpoint: `api/cd/pricememo/${procurementDivisionType}`,
            params: {
              page: currentPage,
              size: pageSize,
              plantId: localStorage.getItem("selectedCDPlantCode")
            }
          })
        );
        setOpen(false);
        setIsBtnDisabled(true);
        setSaveBtnDisabled(true)
      } else {
        console.error(
          "moveToContract action failed:",
          saveSisMaterialIds?.payload
        );
        toast.error(saveSisMaterialIds?.payload?.responseMessage, {
          autoClose: 2000,
        });
      }
    } catch (error) {
      console.log(error);
    }
  }

  const handleMoveDataError = async () => {
    try {
      const moveToDataErrorResponse = await dispatch(
        moveToDataError({
          dynamicEndpoint: `api/cd/pricememo/${procurementDivisionType}/moveToDataError`,
          params: {
            userId: userEmail,
            userName: cleanUsername(userName),
            plantId: plantId,
          },
          data: {
            runOutputSeqId: seqId,
            errorDetails: errorComment,
            isUserDefinedError: true,
          },
        })
      );
      if (moveToDataErrorResponse.meta.requestStatus === "fulfilled") {
        toast.success("Records Moved to Data error", {
          autoClose: 2000,
        });
        dispatch(
          fetchData({
            dynamicEndpoint: `api/cd/pricememo/${procurementDivisionType}`,
            params: {
              page: currentPage,
              size: pageSize,
              plantId: localStorage.getItem("selectedCDPlantCode")
            }
          })
        );
        setOpen(false);
      } else {
        console.error(
          "moveToContract action failed:",
          moveToDataErrorResponse.error
        );
        toast.error(`Something went wrong - ${moveToDataErrorResponse.error}`, {
          autoClose: 2000,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const onSelectionChanged = (params) => {
    const displayedRows = [];
    params?.api?.forEachNodeAfterFilterAndSort((node) => {
      if (node.isSelected()) {
        displayedRows.push(node.data);
      }
    });
  
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;
  
    const rowsInCurrentPage = displayedRows.slice(startIndex, endIndex);
  
    const selectedRows = rowsInCurrentPage.filter((row) =>
      params.api.getSelectedNodes().some((node) => node.data === row)
    );
    setRowsData(selectedRows);
    dispatch(setSelectedItem(selectedRows));
    
    if(selectedRows?.length > 0) {
       setOtherBtnDisabled(false); 
       setSaveBtnDisabled(false) 
    } else { 
      setOtherBtnDisabled(true); 
      setSaveBtnDisabled(true) 
    }
  };

  const rejectHandler = (id) => {
    setOpen(true);
    setSeqId(id);
  };

  const handleTextAreaChange = (e) => {
    setErrorComment(e.target.value);
  };

  const handleSubmitContract = async () => {
    try {
      const allId = rowsData?.map((id) => id.runOutputSeqId);
      const moveToContractResponse = await dispatch(
        moveToContract({
          dynamicEndpoint: `api/cd/pricememo/${procurementDivisionType}/submitToContract`,
          params: {
            userId: userEmail,
            userName: cleanUsername(userName),
            plantId: plantId,
          },
          data: {
            runOutputSeqIds: allId,
          },
        })
      );
      if (moveToContractResponse.meta.requestStatus === "fulfilled") {
        toast.success("Contract Submitted - In Progress", {
          autoClose: 2000,
        });
        dispatch(
          fetchData({
            dynamicEndpoint: `api/cd/pricememo/${procurementDivisionType}`,
            params: {
              page: currentPage,
              size: pageSize,
              plantId: localStorage.getItem("selectedCDPlantCode")
            }
          })
        );
        setIsBtnDisabled(true);
      } else {
        console.error(
          "moveToContract action failed:",
          moveToContractResponse.payload.errorMessage
        );
        toast.error(`${moveToContractResponse.payload.errorMessage}`, {
          autoClose: 2000,
        });
        setIsBtnDisabled(true);
      }
    } catch (error) {
      console.error("API error:", error);
      setIsBtnDisabled(true);
    }
  };

  const rowSelection = useMemo(() => {
    return {
      mode: "multiRow",
      isRowSelectable: (rowNode) =>
        rowNode.data.status.toLowerCase().includes("contract submitted")
          ? true
          : true,
    };
  }, []);

  const getRowStyle = (params) => {
    if (params.data.status.toLowerCase().includes("contract submitted")) {
      return null;
    }
    return null;
  };

  useEffect(() => {
    if (procurementDivisionType) {
      setCurrentPage(1)
      setOtherBtnDisabled(true)
      setIsBtnDisabled(true)
    }
  },[procurementDivisionType])

  const onPageSizeChanged = (event) => {
    setPageSize(Number(event.target.value));
    setCurrentPage(1); // Reset to first page
  };
 
  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const fetchAllSourceData = (index, title, url) => {
    if (title === "Price Memo Source") {
      setOpenSourceModal(true);
      fetchAllPriceMemoSouceData();
    }
    if (title === "Errored Records") {
      navigate('/price-memo/data-errors');
    }
  }

  const fetchAllPriceMemoSouceData = useCallback(async () => {
    setLoading(true);
    try {
      const response = await dispatch(getAllSourcePriceMemoData({
        dynamicEndpoint: `${getAllSourcePricMemo}/${procurementDivisionType}/getAllRecords`,
        params: {
          page: modalCurrentPage,
          size: modalPageSize,
          plantId: localStorage.getItem("selectedCDPlantCode")
        }
      }));
      if (response?.meta?.requestStatus === 'fulfilled') {
        setLoading(false);
        setPmSourceData(response?.payload)
        setModalTotalPages(response?.payload?.totalPages)
        setModalTotalPageItems(response?.payload?.totalNumberOfItems)
        setModalTotalItemCurrentPage(response?.payload?.totalItemsInPage)
      } else {
        console.error('Failed to fetch data:', response.error);
      }
    } catch (error) {
      console.error('API error:', error);
    }
  }, [dispatch, procurementDivisionType, modalCurrentPage, modalPageSize]);

  useEffect(() => {
    const fetchDataFromApi = async () => {
      try {
        const response = await dispatch(fetchData({
          dynamicEndpoint: `api/cd/pricememo/SIS`,
          params: {
            page: currentPage,
            size: pageSize,
            plantId: localStorage.getItem("selectedCDPlantCode")
          }
        }));
        if (response?.meta?.requestStatus === 'fulfilled') {
          setTotalPages(response?.payload?.totalPages)
          setTotalPageItems(response?.payload?.totalNumberOfItems)
          setTotalItemCurrentPage(response?.payload?.totalItemsInPage)
        } else {
          console.error('Failed to fetch data:', response.error);
        }
      } catch (error) {
        console.error('API error:', error);
      }
    };
    fetchDataFromApi();
  }, [dispatch, procurementDivisionType, currentPage, pageSize]);

  const onModalPageSizeChanged = (event) => {
    setModalPageSize(Number(event.target.value));
    setModalCurrentPage(1); // Reset to first page
  };

  const goToModalPage = (page) => {
    if (page >= 1 && page <= modalTotalPages) {
      setModalCurrentPage(page);
    }
  };

  useEffect(() => {
    if (openSourceModal) {
      fetchAllPriceMemoSouceData();
    }
  }, [fetchAllPriceMemoSouceData, openSourceModal, modalCurrentPage, modalPageSize]);

  return (
    <>
      <TopSection
        labelList={[
          { title: "Home", path: "/landing-page" },
          { title: "Price Memo Maintenance" },
        ]}
        hideHeader={true}
        headerName={"Price Memo Maintenance"}
      />
      {piceMemoDataList?.loading === true ? (
        <Loader />
      ) : (
        <>
          <p style={{ marginTop: 0 }}>Price Memo Maintenance {procurementDivisionType}</p>
          <div>
          
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <div className="priceMemo_main">
                  <div className="priceMemo_subCls"></div>
                  {!piceMemoDataList.data ? (
                    <div style={{ textAlign: "center", fontWeight: "bold" }}>
                      No record found
                    </div>
                  ) : (
                    <div className="priceMemo_dataTable">
                      <DataDetails
                        onSelectionChanged={onSelectionChanged}
                        rejectHandler={rejectHandler}
                        rowSelection={rowSelection}
                        getRowStyle={getRowStyle}
                        data={piceMemoDataList?.data}
                        onPageSizeChanged={onPageSizeChanged}
                        goToPage={goToPage}
                        pageSize={pageSize}
                        currentPage={currentPage}
                        totalPages={totalPages}
                        totalPageItems={totalPageItems && totalPageItems}
                        totalItemCurrentPage={totalItemCurrentPage}
                        handleCellValueChange={handleCellValueChange}
                      />
                      <div
                        style={{
                          marginTop: "50px",
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: "30px",
                        }}
                      >
                        <div>
                        </div>
                        <div
                           style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 12,          // <-- actual spacing between buttons
                      flexWrap: "wrap", // <-- wrap nicely if needed
      // width: 400,     // <-- remove this line
    }}
                        >
                            
                            <ButtonComponent
                              label="Save"
                              bgColor="#000"
                              color="#fff"
                              disabled={saveBtnDisabled}
                              onClick={handleSaveSisMaterialId}
                            />
                           
                           <ButtonComponent
                  label="Duplicate"
                  bgColor="#000"
                  color="#fff"
                  disabled={otherBtnDisabled}
                />
                <ButtonComponent
                  label="Add"
                  bgColor="#000"
                  color="#fff"
                  disabled={otherBtnDisabled}
                  //onClick={addContractMaintenanceHandler}
                />
                <ButtonComponent
                  label="Delete"
                  bgColor="#000"
                  color="#fff"
                  disabled={otherBtnDisabled}
                  //onClick={deleteContractMaintenanceHandler}
                />
                          <ButtonComponent
                            label="Cancel"
                            bgColor="#fff"
                            color="#000"
                            disabled={procurementDivisionType === "SIS" ? btnDisabled : otherBtnDisabled}
                          />
                          <ButtonComponent
                            label="Submit for Contract"
                            bgColor="#000"
                            color="#fff"
                            onClick={handleSubmitContract}
                            disabled={procurementDivisionType === "SIS" ? btnDisabled : otherBtnDisabled}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </Grid>
            </Grid>
          </div>
        </>
      )}
      <Modal
        open={open}
        handleClose={handleClose}
        title="Comments"
        content={
          <div>
            <TextareaAutosize
              minRows={3}
              style={{ width: "100%" }}
              onChange={handleTextAreaChange}
            />
            <p>Are you sure you want to move this Line item to Data Errors?</p>
          </div>
        }
        action={
          <ModalFooter
            onClosePopup={handleClose}
            onSubmit={handleMoveDataError}
            errorComment={errorComment}
          />
        }
      />
      <TabModal
        open={openSourceModal}
        handleClose={() => setOpenSourceModal(false)}
        title="Price Memo Source"
        pmSourceData={pmSourceData}
        onPageSizeChanged={onModalPageSizeChanged}
        getRowStyle={getRowStyle}
        pageSize={modalPageSize}
        currentPage={modalCurrentPage}
        totalPages={modalTotalPages}
        totalPageItems={modalTotalPageItems && modalTotalPageItems}
        totalItemCurrentPage={modalTotalItemCurrentPage}
        goToPage={goToModalPage}
        loading={loading}
      />
    </>
  );
};

export default PriceMemoMaintenance;
